import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './context/AuthContext';
import posthog from 'posthog-js';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/**
 * Initialize PostHog only if performance tracking is enabled.
 * This prevents any automatic events (e.g., pageview/pageleave) from being sent
 * when the user has disabled "Enable Performance Tracking".
 */
try {
  const stored = localStorage.getItem('enablePerformanceTracking');
  const trackingEnabled = stored === null || JSON.parse(stored) === true;

  if (trackingEnabled) {
    posthog.init('phc_uPKPi3YhmQCgfDeQOVeDnALHjoThjzlG5R3EFtcoO2o', {
      api_host: 'https://app.posthog.com',
      capture_pageview: true, // Automatically capture page views
      capture_pageleave: true, // Capture when users leave pages
    });
  }
} catch (e) {
  console.warn('PostHog init skipped due to localStorage parse error:', e);
}

// Follow the setup guide in AUTHENTICATION_SETUP_GUIDE.md
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'your_google_client_id_here.apps.googleusercontent.com';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
